"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ts_lib_crypto_1 = require("@waves/ts-lib-crypto");
function wavesAsset2Eth(wavesAsset) {
    var rawBytes = ts_lib_crypto_1.base58Decode(wavesAsset);
    var bytes = rawBytes.slice(0, 20);
    return "0x" + ts_lib_crypto_1.base16Encode(bytes);
}
exports.default = wavesAsset2Eth;
